import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsCreateHeader from '../components/leads/BilisselBecerilerHeader'
import LeadsCreateContent from '../components/leads/BilisselBecerilerEdit'
import Footer from '../components/shared/Footer'

const OrganisationTable = () => {
    return (
        <>
            <PageHeader>
   
            </PageHeader>

            <div className='main-content'>
                <div className='row'>
                    <LeadsCreateContent/>
                </div>
            </div>
            
        </>
    )
}

export default OrganisationTable